import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core'
import { PeriodType, UpgradeType } from '@flowaccount/core/common'
import { TranslateService } from '@ngx-translate/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { map, take } from 'rxjs/operators'
import {
  PackageLevel,
  freePackage,
  PaymentInput,
  CurrentPackageDetail,
  PackageButton,
} from '@flowaccount/domain/financial-domain/common/feature-subscription'
import { PackageService } from '../../service/package-landing.service'
import { Output, EventEmitter } from '@angular/core'
import { isScullyGenerated, TransferStateService } from '@scullyio/ng-lib'
import { Pages } from '../../models/blog.model'
import { SignupFlowService } from '@flowaccount/landing'

const PACKAGE_LIST_KEY = 'packageList'
@Component({
  selector: 'flowaccount-package-landing',
  templateUrl: './package-landing.component.html',
  styleUrls: ['./package-landing.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PackageComponentLanding implements OnInit, OnChanges {
  // variable for landing page
  @Input() isMostPopularOn = false
  @Input() packageType
  @Input() page
  @Input() periodTypeInput

  @Output() periodTypeOutputEvent = new EventEmitter<PeriodType>()
  @Output() trackEvent = new EventEmitter<{ dataId: number; dataName: string }>()
  @Output() trackTogglePeriodTypeEvent = new EventEmitter<void>()

  public isLoading = false
  public isShowLinkPrevioudPage = false
  public currentPackageDetail: CurrentPackageDetail = undefined
  public paymentInput: PaymentInput = new PaymentInput()
  upgradeType: UpgradeType = UpgradeType.Upgrade
  periodType: PeriodType = PeriodType.Year
  upgradeTypeEnum = UpgradeType
  periodTypeEnum = PeriodType
  packageLevelEnum = PackageLevel
  packageVisible: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([])
  isBasicPackageOpen: any
  isPremiumPackageOpen: any
  isAdvancePackageOpen: any
  isBundlePackageOpen: any

  currentPage = Pages
  public windowHeight = 0
  public flowPayrollData = new Array(3)

  public flowPayrollDataProBusiness = new Array(3)
  allPackage: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([])
  public packageDetails = [
    { class: 'blue', icon: 'fa-lightbulb', text: 'PACKAGE_TABLE.DETAIL_PACKAGE.FREE_ONLINE_SETUP' },
    { class: 'layout', icon: 'fa-check', text: 'PACKAGE_TABLE.DETAIL_PACKAGE.PRIVATE_GUIDED_SETUP' },
    { class: 'layout', icon: 'fa-check', text: 'PACKAGE_TABLE.DETAIL_PACKAGE.BASIC_ACCOUNTING_TRAINING' },
  ]
  constructor(
    private packageService: PackageService,
    public cdref: ChangeDetectorRef,
    public element: ElementRef,
    public translate: TranslateService,
    protected tstate: TransferStateService,
    private signupFlowService: SignupFlowService,
  ) {}

  ngOnInit() {
    if (isScullyGenerated()) {
      this.tstate
        .getState(PACKAGE_LIST_KEY)
        .pipe(take(1))
        .subscribe((item: any) => {
          this.allPackage.next(item)
          this.packageVisible.next(item[this.periodType])
        })
    } else {
      this.periodType = PeriodType.Year
      this.packageService
        .getPlanGroup()
        .pipe(
          map((x) => {
            const list = []
            // สำหรับ new user ให้เห็น package ฟรี
            list[PeriodType.Year] = []
            list[PeriodType.Year][0] = freePackage
            list[PeriodType.Month] = []
            list[PeriodType.Month][0] = freePackage
            const resData = x.data

            resData.map((item) => {
              if (list[item.configuration.PeriodType] === undefined) {
                list[item.configuration.PeriodType] = []
              }
              list[item.configuration.PeriodType][item.level] = item
            })
            this.cdref.markForCheck()
            return list
          }),
        )
        .subscribe((item) => {
          this.allPackage.next(item)
          this.packageVisible.next(item[this.periodType])
          this.tstate.setState(PACKAGE_LIST_KEY, item)
        })
    }
    this.cdref.markForCheck()
  }

  ngOnChanges(changes: SimpleChanges) {
    this.togglePeriod(changes.periodTypeInput?.currentValue)
  }

  getPricePostfix(price: number): string {
    if (price > 0) {
      // if (this.periodType === this.periodTypeEnum.Month) {
      //   return 'PACKAGE_TABLE.PER_MONTH'
      // } else {
      //   return 'PACKAGE_TABLE.PER_MONTH'
      // }
      return 'PACKAGE_TABLE.PER_MONTH'
    } else {
      return 'PACKAGE_TABLE.PACKAGE_BASIC.FOREVER'
    }
  }

  getDescription() {
    return this.translate.instant('PACKAGE_TABLE.PACK_SUB_TITLE')
  }
  getTitle() {
    return this.translate.instant('PACKAGE_TABLE.PACK_TITLE')
  }

  displayImageSave(periodType: number) {
    const lang = this.translate.currentLang
    if (periodType === this.periodTypeEnum.Month) {
      return lang === 'th'
        ? 'https://flowaccountcdn.com/new_landing/image/subscription/save_tablet_th.png'
        : 'https://flowaccountcdn.com/new_landing/image/subscription/save_tablet_en.png'
    } else if (periodType === this.periodTypeEnum.Year) {
      return lang === 'th'
        ? 'https://flowaccountcdn.com/new_landing/image/subscription/save_tablet_active_th.png'
        : 'https://flowaccountcdn.com/new_landing/image/subscription/save_tablet_active_en.png'
    }
  }

  displaySubHeading(packageLevel: number) {
    switch (packageLevel) {
      case this.packageLevelEnum.Free:
        return this.translate.instant('PACKAGE_TABLE.PACKAGE_BASIC.FOR')
        break
      case this.packageLevelEnum.Standard:
        return this.translate.instant('PACKAGE_TABLE.PACKAGE_PREMIUM.FOR')
        break
      case this.packageLevelEnum.Pro:
        return this.translate.instant('PACKAGE_TABLE.PACKAGE_ADVANCE.FOR')
        break
      case this.packageLevelEnum.ProBusiness:
        return this.translate.instant('PACKAGE_TABLE.PACKAGE_BUNDLE.FOR')
        break
    }
  }

  displayImageMobileSave(periodType: number) {
    const lang = this.translate.currentLang
    if (periodType === this.periodTypeEnum.Month) {
      return lang === 'th'
        ? 'https://flowaccountcdn.com/new_landing/image/subscription/save_mobile_th.png'
        : 'https://flowaccountcdn.com/new_landing/image/subscription/save_up_mobile_en_gray.png'
    } else if (periodType === this.periodTypeEnum.Year) {
      return lang === 'th'
        ? 'https://flowaccountcdn.com/new_landing/image/subscription/save_mobile_active_th.png'
        : 'https://flowaccountcdn.com/new_landing/image/subscription/save_up_mobile_en.png'
    }
  }

  displayLimitScan(packageLevel: number) {
    switch (packageLevel) {
      case this.packageLevelEnum.Standard:
        return (
          this.translate.instant('PACKAGE_TABLE.AUTOKEY.TEXT_1').replace('###Number###', 100) +
          this.translate.instant('PACKAGE_TABLE.AUTOKEY_PER_MONTH')
        )
        break
      case this.packageLevelEnum.Pro:
        return (
          this.translate.instant('PACKAGE_TABLE.AUTOKEY.TEXT_1').replace('###Number###', 100) +
          this.translate.instant('PACKAGE_TABLE.AUTOKEY_PER_MONTH')
        )
        break
      case this.packageLevelEnum.ProBusiness:
        return this.translate
          .instant('PACKAGE_TABLE.AUTOKEY.TEXT_1')
          .replace('###Number###', this.translate.currentLang === 'th' ? 'ไม่จำกัดจำนวน' : 'Unlimited')
        break
    }
  }

  getButtonClass(packageItem): PackageButton {
    if (packageItem.isFreePackage === true) {
      return {
        class: 'free-package',
        dataId: '101',
        dataName: 'free',
        text: 'PACKAGE_TABLE.BTN_FREE_PACKAGE',
        isDisabled: false,
      }
    } else if (packageItem.level === this.packageLevelEnum.Standard) {
      return {
        class: 'choice-package',
        dataId: '102',
        dataName: 'standard',
        text: 'PACKAGE_TABLE.TRY_30_DAYS',
        isDisabled: false,
      }
    } else if (packageItem.level === this.packageLevelEnum.Pro) {
      return {
        class: this.isMostPopularOn ? 'bundle-package' : 'choice-package',
        dataId: '103',
        dataName: 'pro',
        text: 'PACKAGE_TABLE.TRY_30_DAYS',
        isDisabled: false,
      }
    } else if (packageItem.level === this.packageLevelEnum.ProBusiness) {
      return {
        class: this.isMostPopularOn ? 'choice-package' : 'bundle-package',
        dataId: '104',
        dataName: 'pro business',
        text: 'PACKAGE_TABLE.TRY_30_DAYS',
        isDisabled: false,
      }
    } else {
      return
    }
  }

  onClickToggle(packageLevel: number) {
    switch (packageLevel) {
      case this.packageLevelEnum.Free:
        this.isBasicPackageOpen = !this.isBasicPackageOpen
        break
      case this.packageLevelEnum.Standard:
        this.isPremiumPackageOpen = !this.isPremiumPackageOpen
        break
      case this.packageLevelEnum.Pro:
        this.isAdvancePackageOpen = !this.isAdvancePackageOpen
        break
      case this.packageLevelEnum.ProBusiness:
        this.isBundlePackageOpen = !this.isBundlePackageOpen
        break
    }
  }
  checkTogglePackageList(level: number) {
    switch (level) {
      case this.packageLevelEnum.Free:
        return this.isBasicPackageOpen
      case this.packageLevelEnum.Standard:
        return this.isPremiumPackageOpen
      case this.packageLevelEnum.Pro:
        return this.isAdvancePackageOpen
      case this.packageLevelEnum.ProBusiness:
        return this.isBundlePackageOpen
    }
  }

  togglePeriod(periodType: PeriodType) {
    if (periodType && this.allPackage.value) {
      this.periodType = periodType

      this.packageVisible.next(this.allPackage.value[+this.periodType])

      // Output periodType
      this.periodTypeOutputEvent.emit(this.periodType)
    }
  }

  onTrackTogglePeriod() {
    this.trackTogglePeriodTypeEvent.emit()
  }

  // สำหรับไว้โชว์เมื่อกดรายปี
  displayPricePerMonth(packagePriceYear: number) {
    const pricePerMonth = packagePriceYear ? Math.floor(packagePriceYear / 12) : 0
    const word = this.translate.instant('PACKAGE_TABLE.AVG_PER_MONTH').replace('##price##', pricePerMonth)
    return word
  }
  displayPricePerYear(price: number) {
    const word = this.translate.instant('PACKAGE_TABLE.AVG_PER_YEAR').replace('##price##', price)
    return word
  }
  convertPriceYearlyToMonthly(price: number) {
    const pricePerMonth = price ? Math.floor(price / 12) : 0
    if (this.periodType === this.periodTypeEnum.Year) {
      return pricePerMonth
    } else if (this.periodType === this.periodTypeEnum.Month) {
      return price
    }
  }

  // START: Function for landing page
  showPricingPackage(level: number) {
    if (this.windowHeight < 1100 && this.packageType) {
      if (this.packageType === 'Basic' && level === this.packageLevelEnum.Free) {
        return true
      } else if (this.packageType === 'Premium' && level === this.packageLevelEnum.Standard) {
        return true
      } else if (this.packageType === 'Advance' && level === this.packageLevelEnum.Pro) {
        return true
      } else if (this.packageType === 'Bundle' && level === this.packageLevelEnum.ProBusiness) {
        return true
      }
    } else {
      return true
    }
  }

  checkPackageSubList(packageLevel, index) {
    if (packageLevel === this.packageLevelEnum.ProBusiness) {
      if (index === 2 || index === 3 || index === 4 || index === 5 || index === 6) {
        return true
      } else {
        return false
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize($event) {
    const height = $event.target.innerWidth
    this.windowHeight = height
  }

  loopArray(no: number): number[] {
    return new Array(no)
  }

  goToRegister(dataId: number, dataName: string) {
    window['dataLayer'] = window['dataLayer'] || []
    window['dataLayer'].push({
      event: 'packageSelection',
      packageId: dataId,
      packageName: dataName,
    })
    window['dataLayer'] = window['dataLayer'] || []
    window['dataLayer'].push({
      event: `packageSelection ${dataName}`,
    })

    this.trackEvent.emit({ dataId, dataName })

    const packageNamePreviousPath = this.mappingPackageName(dataId)
    this.signupFlowService.setCookie(packageNamePreviousPath, true)

    window.open(`https://auth.flowaccount.com/${this.translate.currentLang}/Account/Register`)
  }

  private mappingPackageName(packageId: number) {
    switch (packageId.toString()) {
      case '101':
        return 'free-package'
      case '102':
        return 'standard-package'
      case '103':
        return 'pro-package'
      case '104':
        return 'pro-business-package'
      default:
        return ''
    }
  }
}
